import {defaultStories, defaultStory} from './stories.consts'
import {GetStoriesQuery} from './stories.generated'
import {UIFigureVersion, UiStories, UiStoryNode} from './stories.types'

const storiesAdapterServerToClient = (response: GetStoriesQuery): UiStories => {
  if (response.stories === null || response.stories === undefined) {
    return defaultStories
  }

  const {pageInfo} = response.stories
  const {hasNextPage, endCursor} = pageInfo

  const edges: {
    node: UiStoryNode
  }[] =
    response.stories.edges.map(edge => {
      if (edge === null || edge.node === null || edge.node === undefined) {
        return {
          node: defaultStory
        }
      }

      const {id, uid, title, canonicalUrl, isActive, status, updatedAt, publicationsCount, figureVersion} = edge.node
      const updatedAtVal = new Date(updatedAt)

      let curFigureVersion: UIFigureVersion
      if (figureVersion) {
        const {id: figureVersionId, uid: figureVersionUid, figure, primaryProcessedImage} = figureVersion

        const {id: figureId, uid: figureUid} = figure

        curFigureVersion = {
          id: figureVersionId,
          uid: figureVersionUid,
          figure: {
            id: figureId,
            uid: figureUid
          },
          primaryProcessedImage: {
            url: primaryProcessedImage?.url ?? ''
          }
        }
      } else {
        curFigureVersion = defaultStory.figureVersion
      }

      return {
        node: {
          canonicalUrl: canonicalUrl ?? defaultStory.canonicalUrl,
          description: '',
          id: id ?? defaultStory.id,
          isActive: isActive || false,
          status: status ?? defaultStory.status,
          title: title ?? defaultStory.title,
          publicationsCount: publicationsCount ?? defaultStory.publicationsCount,
          uid: uid ?? defaultStory.uid,
          updatedAt: updatedAtVal ?? defaultStory.updatedAt,
          figureVersion: curFigureVersion
        }
      }
    }) ?? defaultStories.edges

  return {
    edges,
    pageInfo: {
      endCursor: endCursor ?? defaultStories.pageInfo.endCursor,
      hasNextPage: hasNextPage ?? defaultStories.pageInfo.hasNextPage
    }
  }
  /* eslint-enable camelcase */
}

export default storiesAdapterServerToClient
